import { CloseOutlined } from '@ant-design/icons'
import { Modal, Space } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import BpInfo from './bpInfo'
import DownPaymentsInfo from './downPaymentsInfo'
import ImageTab from './imageInfo'
import ProductionInViewSales from './Production'
import SalesInfo from './salesInfo'
import ShippedSalesInfo from './shippedInfo'

const ViewSalesModal = ({
	visible,
	data,
	onClose,
	ship = false,
	incoming = false,
	finishSale = false,
	refetch,
	isShowShippedTab = true,
	isShowProductionTab = true,
	isFinishedSalesMenu = false,
	isShowProfit = false,
}) => {
	const renderContent = () => {
		switch (activeTab) {
			case 'tab1':
				return (
					<SalesInfo
						data={data}
						onClose={onCloseModal}
						ship={ship}
						incoming={incoming}
						refetch={refetch}
						finishSale={finishSale}
						visible
						isFinishedSalesMenu={isFinishedSalesMenu}
						isShowProfit={isShowProfit}
					/>
				)
			case 'tab2':
				return (
					<ShippedSalesInfo
						data={data}
						onClose={onCloseModal}
						ship={ship}
						incoming={incoming}
						refetch={refetch}
						finishSale={finishSale}
					/>
				)
			case 'tab3':
				return <BpInfo cardCode={data?.cardCode} />
			case 'tab4':
				return (
					<ProductionInViewSales
						docEntry={
							data?.documentLines[0]?.baseEntry || data?.docEntry
						}
					/>
				)
			case 'tab5':
				return (
					<DownPaymentsInfo docEntry={data?.docEntry} data={data} />
				)
			case 'tab6':
				return <ImageTab data={data} />

			default:
				return null
		}
	}
	const { t } = useTranslation()

	const [activeTab, setActiveTab] = useState('tab1')

	const onCloseModal = () => {
		onClose()
		setActiveTab('tab1')
	}

	if (!data) return null

	return (
		<Modal
			title={
				<h1 className="font-nunito text-xl font-extrabold text-[#000000]">
					{t('order')} № {data?.docNumPrefix}
				</h1>
			}
			open={visible}
			onCancel={onCloseModal}
			footer={null}
			closeIcon={<CloseOutlined />}
			width="90%"
		>
			<Space style={{ marginBottom: 16 }} className="mt-5">
				<button
					className={`${
						activeTab === 'tab1'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold `}
					onClick={() => setActiveTab('tab1')}
				>
					{t('salesInfo')}
				</button>
				{/* {isShowShippedTab && (
					<button
						className={`${
							activeTab === 'tab2'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold `}
						onClick={() => setActiveTab('tab2')}
					>
						{t('shippedSalesInfo')}
					</button>
				)} */}

				<button
					className={`${
						activeTab === 'tab3'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab3')}
				>
					{t('bpInfo')}
				</button>
				{isShowProductionTab && (
					<button
						className={`${
							activeTab === 'tab4'
								? 'text-blue-900 underline underline-offset-8'
								: ''
						} font-semibold ml-3`}
						onClick={() => setActiveTab('tab4')}
					>
						{t('production')}
					</button>
				)}

				<button
					className={`${
						activeTab === 'tab5'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab5')}
				>
					{t('payments')}
				</button>
				<button
					className={`${
						activeTab === 'tab6'
							? 'text-blue-900 underline underline-offset-8'
							: ''
					} font-semibold ml-3`}
					onClick={() => setActiveTab('tab6')}
				>
					{t('drawingPhoto')}
				</button>
			</Space>
			<div className="mt-5">{renderContent()}</div>
		</Modal>
	)
}

export default ViewSalesModal
